import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { FormErrorComponent } from '../form-error/form-error.component';
import { FormLabelComponent } from '../form-label/form-label.component';

@Component({
    selector: 'dropdown-fc-accounts',
    standalone: true,
    imports: [
        FormLabelComponent,
        TranslateModule,
        SelectModule,
        MultiSelectModule,
        FormErrorComponent,
        ReactiveFormsModule,
    ],
    templateUrl: './dropdown-fc-accounts.component.html',
    styleUrl: './dropdown-fc-accounts.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownFcAccountsComponent {
    private translate = inject(TranslateService);

    id = input.required<string>();
    control = input.required<FormControl>();
    options = input.required<any[]>();

    multiple = input<boolean>(false);
    editable = input<boolean>(false);

    optionLabel = input<string | undefined>('fullName');
    optionValue = input<string | undefined>('id');

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);
    showClear = input<boolean>(true);
    filter = input<boolean>(true);
    filterBy = input<string>('fullName,email');

    size = input<'small' | 'large'>('large');

    placeholder = input<string>('uiKit.form.dropdownAccounts.placeholder');
    emptyMessage = input<string>('');
    name = input<string>(''); //used for validation messages, if there is no label

    appendTo = input<string>('body');

    onChange = output<any>();

    readonly errorMessages: Record<string, (label: string, control: FormControl, error: any) => string> = {
        required: () => `${this.translate.instant('uiKit.form.dropdown-fc.emptySelectFormValidator')}`,
    };

    getErrorMessage(error: string): string {
        const label = this.label() ? this.label() : this.name();

        return this.errorMessages[error]
            ? this.errorMessages[error](label, this.control(), this.control().errors && this.control().errors?.[error])
            : '';
    }

    getErrorKeys(errors: ValidationErrors | null): string[] {
        return errors ? Object.keys(errors) : [];
    }
}
